export const DEFAULT_LANGUAGE = '00';

export enum Language {
  CHINESE = `ZH`,
  ENGLISH = `EN`,
  FRENCH = `FR`,
  GERMAN = `DE`,
  SPANISH = `ES`,
  TURKISH = `TR`,
}

export const AVAILABLE_LANGUAGES = Object.values(Language).map((l) =>
  l.toLowerCase(),
);
